/**
 * Legalbus COP REST API 1.0
 * REST API for the Legalbus COP digital signature platform
 *
 * The version of the OpenAPI document: 2.30.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UrlInfo } from './urlInfo';
import { ChoiceInfo } from './choiceInfo';


export interface Clause { 
    id?: string;
    text?: string;
    title?: string;
    group?: string;
    optional?: boolean;
    defaultValue?: boolean;
    urls?: Array<UrlInfo>;
    mode?: Clause.ModeEnum;
    choiceInfo?: ChoiceInfo;
}
export namespace Clause {
    export type ModeEnum = 'CHECK' | 'CHOICE' | 'FIXED';
    export const ModeEnum = {
        Check: 'CHECK' as ModeEnum,
        Choice: 'CHOICE' as ModeEnum,
        Fixed: 'FIXED' as ModeEnum
    };
}


